import { render, staticRenderFns } from "./Sequence.vue?vue&type=template&id=2850ca9d&scoped=true"
import script from "./Sequence.vue?vue&type=script&lang=js"
export * from "./Sequence.vue?vue&type=script&lang=js"
import style0 from "./Sequence.vue?vue&type=style&index=0&id=2850ca9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850ca9d",
  null
  
)

export default component.exports